import { AccountRoleTypes, EEntities, SpamTypes } from '@/types'

export default new class TypeAssistant {
  public getSpamType(spamStatus: string): SpamTypes {
    switch (spamStatus) {
      case 'not_spam':
        return SpamTypes.NOT_SPAM
      case 'potential_spam':
        return SpamTypes.POTENTIAL_SPAM
      case 'spam':
        return SpamTypes.SPAM
    }
  }
  public isSpam(spamType: number): boolean {
    return spamType !== SpamTypes.NOT_SPAM
  }
  public getEntityTypeID(entityType: EEntities): number {
    switch (entityType) {
      case EEntities.PROJECTS:
        return 1
      case EEntities.MAILBOXES:
        return 2
    }
  }
  public getEntityType(entityTypeID: number): EEntities {
    switch (entityTypeID) {
      case 1:
        return EEntities.PROJECTS
      case 2:
        return EEntities.MAILBOXES
    }
  }
  public isProject(entityTypeID: number): boolean {
    return entityTypeID === 1
  }
  public isMailbox(entityTypeID: number): boolean {
    return entityTypeID === 2
  }

  public isOwnerRole(accountRoleID: number): boolean {
    return accountRoleID === AccountRoleTypes.OWNER
  }

  public isAdminRole(accountRoleID: number): boolean {
    return accountRoleID === AccountRoleTypes.ADMIN
  }

  public isNormalRole(accountRoleID: number): boolean {
    return accountRoleID === AccountRoleTypes.NORMAL
  }

  /*
  public isDueTypeDateRangeOption(id: number): boolean {
    return id === 4
  }
  public getDueTypeDateRangeOptionID(): number {
    return 4
  }
  public getDueTypeAllOptionID(): number {
    return -1
  }
  public getDueTypeAnytimeOptionID(): number {
    return 1
  }*/
}()
